// API
export const API_MESSAGES = "API_MESSAGES";
export const API_DRAFT = "API_DRAFT";
export const API_MESSAGE = "API_MESSAGE";
export const API_MESSAGE_BODY = "API_MESSAGE_BODY";
export const API_MESSAGE_SUBJECT_CATEGORY = "API_MESSAGE_SUBJECT_CATEGORY";
export const API_EMPLOYEE = "API_EMPLOYEE";
export const API_MESSAGES_RECEIVED = "API_MESSAGES_RECEIVED";
export const API_MAILBOXES = "API_MAILBOXES";
export const API_MAILBOX = "API_MAILBOX";
// USER SETTINGS
export const USER_SETTINGS_LOCAL = "USER_SETTINGS_LOCAL";
export const USER_DRAFT_UPDATED = "USER_DRAFT_UPDATED";
export const USER_SETTINGS_GLOBAL = "USER_SETTINGS_GLOBAL";
export const USER_SETTINGS_LOCAL_SIDEBAR = "USER_SETTINGS_LOCAL_SIDEBAR";
export const USER_SETTINGS_GLOBAL_THEME = "USER_SETTINGS_GLOBAL_THEME";
export const USER_SETTINGS_GLOBAL_FAVORITE_ACCOUNTS =
  "USER_SETTINGS_GLOBAL_FAVORITE_ACCOUNTS";
export const USER_SITES = "USER_SITES";
export const USER_SETTINGS_GLOBAL_LAST_USED_SETTINGS =
  "USER_SETTINGS_GLOBAL_LAST_USED_SETTINGS";
export const USER_SETTINGS_LOCAL_SIDEBAR_OPEN =
  "USER_SETTINGS_LOCAL_SIDEBAR_OPEN";
export const USER_SETTINGS_GLOBAL_SIDEBAR = "USER_SETTINGS_GLOBAL_SIDEBAR";
export const USER_SETTINGS_GLOBAL_SIDEBAR_VISIBLE =
  "USER_SETTINGS_GLOBAL_SIDEBAR_VISIBLE";
export const USER_SETTINGS_LOCAL_DRAFTS = "USER_SETTINGS_LOCAL_DRAFTS";
export const USER_PERMISSIONS_DETAILED = "USER_PERMISSIONS_DETAILED";
